/* Dosmicos 2026 — storefront behaviour.
 *
 * Ports the interactions the Claude Design prototype specified in its annotations:
 * mega menu (click/Enter to open, Escape and focus-loss to close), mobile drawer,
 * search overlay with predictive results, collection filters, PDP gallery/variant
 * picker, embroidery add-on, sticky add-to-cart and the cart drawer.
 *
 * No framework. Everything is progressive: with JS off, links still navigate and
 * the add-to-cart form still posts.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var money = window.dmMoneyFormat || '${{amount}}';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    // Mirrors Shopify's money filter for the shop's format string.
    var value = (cents / 100);
    function withDelimiters(number, precision, thousands, decimal) {
      number = (number || 0).toFixed(precision);
      var parts = number.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? head + decimal + parts[1] : head;
    }
    var out;
    if (/amount_no_decimals_with_comma_separator/.test(money)) out = withDelimiters(value, 0, '.', ',');
    else if (/amount_with_comma_separator/.test(money)) out = withDelimiters(value, 2, '.', ',');
    else if (/amount_no_decimals/.test(money)) out = withDelimiters(value, 0, ',', '.');
    else out = withDelimiters(value, 2, ',', '.');
    return money.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ---------------- Overlay controller ----------------
     One controller for every overlay so only one can be open, Escape always
     closes, body scroll is locked while open and focus returns to the trigger. */
  var Overlay = (function () {
    var open = null, lastTrigger = null;

    function close() {
      if (!open) return;
      var el = document.getElementById(open);
      if (el) el.hidden = true;
      $$('[data-dm-scrim="' + open + '"]').forEach(function (s) { s.hidden = true; });
      $$('[aria-controls="' + open + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.classList.remove('dm-noscroll');
      open = null;
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      lastTrigger = null;
    }

    function show(id, trigger) {
      if (open === id) { close(); return; }
      close();
      var el = document.getElementById(id);
      if (!el) return;
      el.hidden = false;
      $$('[data-dm-scrim="' + id + '"]').forEach(function (s) { s.hidden = false; });
      $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (!el.classList.contains('dm-mega')) document.body.classList.add('dm-noscroll');
      open = id;
      lastTrigger = trigger || null;
      var focusable = el.querySelector('[autofocus], input:not([type=hidden]), button, a[href]');
      if (focusable) focusable.focus({ preventScroll: true });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-dm-open]');
      if (trigger) { e.preventDefault(); show(trigger.getAttribute('data-dm-open'), trigger); return; }
      if (e.target.closest('[data-dm-close]')) { e.preventDefault(); close(); return; }
      // Click outside an open mega menu closes it; other overlays have a scrim.
      if (open) {
        var el = document.getElementById(open);
        if (el && el.classList.contains('dm-mega') && !el.contains(e.target) && !e.target.closest('[data-dm-open]')) close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab' || !open) return;
      var el = document.getElementById(open);
      // El mega menú no atrapa el foco a propósito: salir de él con Tab es lo que lo cierra.
      if (!el || el.classList.contains('dm-mega')) return;
      var list = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
        .filter(function (n) { return !n.hidden && n.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Focus leaving the mega menu closes it, per the design's annotation.
    document.addEventListener('focusin', function (e) {
      if (!open) return;
      var el = document.getElementById(open);
      if (!el || !el.classList.contains('dm-mega')) return;
      if (!el.contains(e.target) && !e.target.closest('[aria-controls="' + open + '"]')) close();
    });

    return { show: show, close: close, current: function () { return open; } };
  })();
  window.dmOverlay = Overlay;

  /* ---------------- Disclosures (accordions, filter groups) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dm-toggle]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  });

  /* ---------------- Guía TOG ----------------
     El copy de las ocho respuestas ya está impreso y oculto en el HTML; aquí solo se
     decide cuál se ve. Nada de armar marcado con cadenas: lo que se lee es lo que
     escribió el editor. */
  (function () {
    var sheet = document.getElementById('dm-tog');
    if (!sheet) return;
    var answer = $('#dm-tog-answer', sheet);
    var picks = $$('[data-dm-tog-pick]', sheet);
    var panels = $$('[data-dm-tog-panel]', sheet);
    var current = null;

    function render() {
      picks.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-dm-tog-pick') === current));
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-dm-tog-panel') !== current; });
      answer.hidden = current === null;
    }

    sheet.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dm-tog-pick]');
      if (!b) return;
      var i = b.getAttribute('data-dm-tog-pick');
      // Volver a tocar la fila elegida la deselecciona y esconde el paso 2.
      current = current === i ? null : i;
      render();
    });

    // Cada apertura arranca limpia. Si el disparador declara un TOG —la ficha de un
    // sleeping sabe el suyo— esa fila queda preseleccionada.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-dm-open="dm-tog"]');
      if (!trigger) return;
      var preset = trigger.getAttribute('data-dm-tog-preset');
      current = null;
      if (preset) {
        picks.forEach(function (b) {
          if (b.getAttribute('data-tog') === preset) current = b.getAttribute('data-dm-tog-pick');
        });
      }
      render();
      var acc = $('[data-dm-toggle]', sheet);
      if (acc) acc.setAttribute('aria-expanded', 'false');
    });

    render();
  })();

  /* ---------------- Tabla de tallas (ruanas) ----------------
     Mismo patrón que la guía TOG: las respuestas ya están impresas y ocultas, aquí solo se
     decide cuál se ve. Lo propio de esta guía es el botón "Elegir talla N", que solo
     aparece cuando el modal se abrió desde una ficha. */
  (function () {
    var sheet = document.getElementById('dm-sg');
    if (!sheet) return;
    var answer = $('#dm-sg-answer', sheet);
    var picks = $$('[data-dm-sg-pick]', sheet);
    var panels = $$('[data-dm-sg-panel]', sheet);
    var rows = $$('[data-dm-sg-tr]', sheet);
    var current = null, canApply = false;

    // La talla del catálogo viene como "6 (3 - 4 años)": lo que identifica la talla es el
    // número de adelante, no la cadena completa.
    function leadingNumber(text) {
      var m = String(text || '').trim().match(/^(\d+)/);
      return m ? m[1] : null;
    }

    function sizeButton(talla) {
      return $$('[data-dm-option][data-value]').filter(function (b) {
        return leadingNumber(b.getAttribute('data-value')) === String(talla);
      })[0];
    }

    function render() {
      picks.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-dm-sg-pick') === current));
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-dm-sg-panel') !== current; });
      // La fila elegida se resalta también en la tabla completa.
      rows.forEach(function (tr) { tr.setAttribute('data-on', String(tr.getAttribute('data-dm-sg-tr') === current)); });
      answer.hidden = current === null;
      if (current === null) return;

      var panel = panels.filter(function (p) { return p.getAttribute('data-dm-sg-panel') === current; })[0];
      var apply = $('[data-dm-sg-apply-btn]', panel);
      var sold = $('[data-dm-sg-sold]', panel);
      var btn = canApply ? sizeButton(panel.getAttribute('data-talla')) : null;
      var available = btn && btn.getAttribute('aria-disabled') !== 'true';
      // Agotada: no se ofrece aplicarla, se dice por qué. Un botón que no hace nada es peor.
      if (apply) apply.hidden = !available;
      if (sold) sold.hidden = !(canApply && btn && !available);
    }

    sheet.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dm-sg-pick]');
      if (b) {
        var i = b.getAttribute('data-dm-sg-pick');
        current = current === i ? null : i;   // volver a tocarla deselecciona
        render();
        return;
      }
      var apply = e.target.closest('[data-dm-sg-apply-btn]');
      if (!apply) return;
      var panel = apply.closest('[data-dm-sg-panel]');
      var target = sizeButton(panel.getAttribute('data-talla'));
      // Se aplica pulsando el control real de la ficha, no duplicando su lógica.
      if (target) target.click();
      Overlay.close();
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-dm-open="dm-sg"]');
      if (!trigger) return;
      canApply = trigger.hasAttribute('data-dm-sg-apply');
      current = null;
      render();
      var acc = $('[data-dm-toggle]', sheet);
      if (acc) acc.setAttribute('aria-expanded', 'false');
    });

    render();
  })();

  /* ---------------- Cart ---------------- */
  var Cart = {
    add: function (items) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'No pudimos agregar el producto.');
          return body;
        });
      });
    },
    // Copia a las insignias del encabezado el número que la bolsa trae dentro
    // ([data-dm-cart-total]). Antes se buscaba la insignia en el HTML de la bolsa, donde
    // no existe —vive en la sección del header—, así que nunca se actualizaba: tras
    // quitar un producto seguía diciendo 2 hasta recargar.
    syncCount: function () {
      var src = $('#dm-cart [data-dm-cart-total]');
      if (!src) return;
      var n = parseInt(src.textContent, 10) || 0;
      $$('[data-dm-cart-count]').forEach(function (el) {
        el.textContent = String(n);
        el.hidden = n === 0;
      });
      $$('[data-dm-open="dm-cart"][aria-label]').forEach(function (b) {
        b.setAttribute('aria-label', n > 0 ? 'Tu bolsa, ' + n + (n === 1 ? ' artículo' : ' artículos') : 'Tu bolsa, vacía');
      });
    },
    refresh: function () {
      // Re-render the drawer from the cart section; the count comes along inside it.
      return fetch(window.Shopify.routes.root + '?section_id=dm-cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#dm-cart');
          var current = document.getElementById('dm-cart');
          if (fresh && current) {
            var wasOpen = !current.hidden;
            current.innerHTML = fresh.innerHTML;
            current.hidden = !wasOpen;
          }
          Cart.syncCount();
        });
    }
  };
  window.dmCart = Cart;

  /* Cambios del carrito que no hace el tema.
     Las apps (el "a menudo se compran juntos" de Sewdle, por ejemplo) agregan con su
     propio fetch a /cart/add.js y el tema no se enteraba: ni abría la bolsa ni movía el
     contador. Se observa el fetch global: cualquier mutación del carrito re-renderiza la
     bolsa, y si fue un "add" la abre, igual que el botón propio de la ficha.
     Los flujos del tema también pasan por aquí; el debounce junta todo en un refresco. */
  (function () {
    if (!window.fetch || window.fetch.__dmWrapped) return;
    var native = window.fetch, timer = null, pendingOpen = false;
    function schedule(open) {
      pendingOpen = pendingOpen || open;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var open = pendingOpen; pendingOpen = false;
        Cart.refresh().then(function () {
          var drawer = document.getElementById('dm-cart');
          // Overlay.show alterna: si ya está abierta no se vuelve a llamar, o la cerraría.
          if (open && drawer && drawer.hidden) Overlay.show('dm-cart');
        }).catch(function () { /* la bolsa se actualizará en la próxima acción */ });
      }, 250);
    }
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var m = url.match(/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/);
      var p = native.apply(this, arguments);
      if (m) p.then(function (r) { if (r && r.ok) schedule(m[1] === 'add'); }, function () {});
      return p;
    };
    window.fetch.__dmWrapped = true;

    // Si una app reemplaza el contenido de la bolsa por su cuenta, el número que viene
    // dentro también cambia: se copia a las insignias sin depender de quién lo hizo.
    var drawer = document.getElementById('dm-cart');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { Cart.syncCount(); }).observe(drawer, { childList: true });
    }
    Cart.syncCount();
  })();

  function toast(message) {
    var old = $('.dm-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'dm-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="dm-toast__icon" aria-hidden="true">' + (window.dmIcons ? window.dmIcons.check : '✓') + '</span>' +
      '<p></p>' +
      '<button type="button" class="dm-btn dm-btn--primary" style="min-height:36px;padding:0 12px" data-dm-open="dm-cart">Ver bolsa</button>';
    el.querySelector('p').textContent = message;
    document.body.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 4200);
  }
  window.dmToast = toast;

  /* ---------------- Quick add on product cards ----------------
     The design is explicit: no size is pre-selected. "Agregar" opens the size
     picker and only the confirm button adds, and only once a size is chosen. */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.dm-card');
    if (!card) return;

    if (e.target.closest('[data-dm-qa-open]')) {
      e.preventDefault();
      $('[data-dm-qa-trigger]', card).hidden = true;
      $('[data-dm-qa-panel]', card).hidden = false;
      return;
    }

    var sizeBtn = e.target.closest('[data-dm-qa-size]');
    if (sizeBtn) {
      e.preventDefault();
      if (sizeBtn.getAttribute('aria-disabled') === 'true') return;
      $$('[data-dm-qa-size]', card).forEach(function (b) { b.setAttribute('aria-pressed', String(b === sizeBtn)); });
      var confirm = $('[data-dm-qa-confirm]', card);
      confirm.removeAttribute('aria-disabled');
      confirm.dataset.variant = sizeBtn.dataset.variant;
      confirm.dataset.size = sizeBtn.dataset.size;
      confirm.textContent = 'Agregar talla ' + sizeBtn.dataset.size;
      return;
    }

    var confirmBtn = e.target.closest('[data-dm-qa-confirm]');
    if (confirmBtn) {
      e.preventDefault();
      if (confirmBtn.getAttribute('aria-disabled') === 'true' || !confirmBtn.dataset.variant) return;
      confirmBtn.textContent = 'Agregando…';
      Cart.add([{ id: confirmBtn.dataset.variant, quantity: 1 }])
        .then(function () { return Cart.refresh(); })
        .then(function () {
          var panel = $('[data-dm-qa-panel]', card);
          panel.hidden = true;
          var done = $('[data-dm-qa-done]', card);
          done.hidden = false;
          done.querySelector('span.dm-qa-size').textContent = confirmBtn.dataset.size;
          toast('Agregaste ' + card.dataset.title + ', talla ' + confirmBtn.dataset.size + '.');
        })
        .catch(function (err) {
          confirmBtn.textContent = 'Agregar talla ' + confirmBtn.dataset.size;
          alert(err.message);
        });
      return;
    }

    // Swatches switch the card image without leaving the grid.
    var swatch = e.target.closest('[data-dm-swatch]');
    if (swatch) {
      e.preventDefault();
      $$('[data-dm-swatch]', card).forEach(function (s) { s.setAttribute('aria-pressed', String(s === swatch)); });
      var img = $('.dm-card__img', card);
      if (img && swatch.dataset.img) { img.src = swatch.dataset.img; img.srcset = ''; }
      var nameEl = $('[data-dm-swatch-name]', card);
      if (nameEl) nameEl.textContent = swatch.dataset.name;
      var link = $('.dm-card__link', card);
      if (link && swatch.dataset.url) link.setAttribute('href', swatch.dataset.url);
    }
  });

  /* ---------------- Collection ---------------- */
  var toolbar = $('[data-dm-toolbar]');
  if (toolbar) {
    // Keep the sticky toolbar directly under the sticky header.
    var header = $('.dm-header');
    var sidebar = $('.dm-sidebar');
    var setTop = function () {
      var headerH = header ? header.offsetHeight : 0;
      toolbar.style.top = Math.max(0, headerH - 1) + 'px';
      // The filter column has to clear the header *and* the toolbar, otherwise its
      // first rows sit behind the toolbar once the page scrolls.
      if (sidebar) sidebar.style.top = (headerH + toolbar.offsetHeight + 12) + 'px';
    };
    setTop();
    window.addEventListener('resize', setTop);
    if (window.ResizeObserver && header) new ResizeObserver(setTop).observe(header);
    if (window.ResizeObserver) new ResizeObserver(setTop).observe(toolbar);

    var sidebarToggle = $('[data-dm-sidebar-toggle]');
    var colBody = $('[data-dm-col-body]');
    if (sidebarToggle && colBody) {
      // El mismo botón hace dos cosas: en escritorio muestra/oculta la columna de
      // filtros, en móvil abre el panel. La etiqueta tiene que decir cuál de las dos,
      // y el Liquid no puede saber el ancho, así que se resuelve aquí.
      function syncFilterLabel() {
        var label = $('[data-dm-filter-label]', sidebarToggle);
        if (!label) return;
        if (window.matchMedia('(max-width:1023px)').matches) { label.textContent = 'Filtrar'; return; }
        label.textContent = colBody.dataset.sidebar === 'off' ? 'Filtrar y ordenar' : 'Ocultar filtros';
      }
      sidebarToggle.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width:1023px)').matches) return;
        e.preventDefault();
        var off = colBody.dataset.sidebar === 'off';
        colBody.dataset.sidebar = off ? 'on' : 'off';
        sidebarToggle.setAttribute('aria-expanded', String(off));
        syncFilterLabel();
        var quick = $('[data-dm-quick]');
        if (quick) quick.classList.toggle('dm-quick--forced', !off);
      });
      window.addEventListener('resize', syncFilterLabel);
      syncFilterLabel();
    }

    // Filters and sort are plain links/forms so every state has a shareable URL,
    // exactly as the design annotation requires. We only add the auto-submit.
    $$('[data-dm-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () { el.closest('form').submit(); });
    });
  }

  /* ---------------- Cargar más ----------------
     El botón agrega los productos debajo en vez de navegar. Antes llevaba a la página 2
     sin forma evidente de volver, que es lo que rompía la lectura de la colección.

     Se mantiene como <a> con la URL real: sin JS navega igual, y abrir en pestaña nueva
     sigue funcionando. Solo se intercepta el clic simple. */
  (function loadMore() {
    var wrap = $('[data-dm-more]');
    var root = $('[data-dm-collection]');
    var target = $('[data-dm-grid-append]');
    if (!root) return;

    var total = parseInt(root.dataset.dmTotal, 10) || 0;
    // Con filtro de talla, el total de Shopify cuenta prendas que se descartaron por estar
    // agotadas en esa talla. No sirve para "quedan N": se cuenta lo que hay en pantalla.
    var exact = root.dataset.dmExact !== 'false';
    var meta = $('[data-dm-more-meta]');
    var count = $('.dm-toolbar__count');
    var loading = false;

    // El filtro de talla descarta las variantes agotadas después de que Shopify
    // calcula sus totales. También hay que contar las tarjetas cuando solo hay una
    // página y, por tanto, no existe el botón «Cargar más».
    if (!exact && !wrap) {
      var visible = $$('.dm-results .dm-grid > *').length;
      if (count) count.textContent = visible + (visible === 1 ? ' producto con ' : ' productos con ') + (root.dataset.dmSizeLabel || 'la talla elegida') + ' disponible';
    }
    if (!wrap || !target) return;

    function contados() { return $$('.dm-results .dm-grid > *').length; }

    function repintar(siguienteUrl) {
      var n = contados();
      var restantes = Math.max(0, total - n);
      var texto = exact
        ? 'Viendo 1–' + n + ' de ' + total + ' productos'
        : 'Viendo ' + n + ' ' + (n === 1 ? 'producto' : 'productos');
      if (meta) meta.textContent = texto;
      // El contador de la barra tiene aria-live: al actualizarlo se anuncia el avance.
      if (count) {
        count.textContent = exact
          ? texto
          : n + (n === 1 ? ' producto con ' : ' productos con ') + (root.dataset.dmSizeLabel || 'la talla elegida') + ' disponible';
      }
      var btn = $('[data-dm-load-more]');
      if (!siguienteUrl || (exact && restantes === 0)) { wrap.remove(); return; }
      btn.setAttribute('href', siguienteUrl);
      btn.textContent = exact ? 'Cargar más (' + restantes + ' restantes)' : 'Cargar más';
    }

    // Al entrar, la barra aún no tiene número cuando el conteo de Shopify no sirve.
    if (!exact) repintar($('[data-dm-load-more]') ? $('[data-dm-load-more]').getAttribute('href') : null);

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dm-load-more]');
      if (!btn) return;
      // Respetar clic del medio, cmd/ctrl y abrir en pestaña nueva.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      if (loading) return;
      loading = true;
      var etiqueta = btn.textContent;
      btn.textContent = 'Cargando…';
      btn.setAttribute('aria-busy', 'true');

      fetch(btn.getAttribute('href'), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // Solo las tarjetas: así no se arrastra el bloque educativo ni los encabezados.
          var nuevos = doc.querySelectorAll('.dm-results .dm-grid > *');
          if (!nuevos.length) { wrap.remove(); return; }
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(nuevos, function (el) { frag.appendChild(el); });
          var primero = frag.firstElementChild;
          target.appendChild(frag);
          var sig = doc.querySelector('[data-dm-load-more]');
          repintar(sig ? sig.getAttribute('href') : null);
          // Llevar el foco al primer producto nuevo: sin esto, con teclado el foco queda
          // en un botón que ahora está muy abajo y se pierde el hilo.
          var enlace = primero && primero.querySelector('a');
          if (enlace) { enlace.setAttribute('tabindex', '-1'); enlace.focus({ preventScroll: true }); }
        })
        .catch(function () {
          // Si la petición falla, que el enlace haga lo de siempre.
          window.location.href = btn.getAttribute('href');
        })
        .then(function () {
          loading = false;
          var b = $('[data-dm-load-more]');
          if (b && b.textContent === 'Cargando…') b.textContent = etiqueta;
          if (b) b.removeAttribute('aria-busy');
        });
    });
  })();

  /* ---------------- Product ---------------- */
  var pdp = $('[data-dm-pdp]');
  if (pdp) {
    var variants = [];
    try { variants = JSON.parse($('[data-dm-variants]', pdp).textContent); } catch (e) { variants = []; }

    var state = { options: {}, qty: 1, emb: false };
    var optionNames = JSON.parse(pdp.dataset.dmOptions || '[]');
    var embPrice = parseInt(pdp.dataset.dmEmbPrice || '0', 10);
    var priceEl = $('[data-dm-price]', pdp);
    var addBtn = $('[data-dm-add]', pdp);
    var variantField = $('[data-dm-variant-field]', pdp);
    var announcedVariantState = '';
    var stickyPrice = $('[data-dm-sticky-price]');
    var stickySize = $('[data-dm-sticky-size]');
    var stickyBar = $('.dm-sticky');

    function currentVariant() {
      var chosen = optionNames.map(function (n) { return state.options[n]; });
      if (chosen.some(function (v) { return !v; })) return null;
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      })[0] || null;
    }

    function sizeOptionName() {
      // The size axis is whichever option is named Talla / Size / Edad.
      // «Tamaño» y «Size» también nombran la talla en parte del catálogo.
      var match = optionNames.filter(function (n) { return /talla|tama|size|edad/i.test(n); })[0];
      return match || optionNames[optionNames.length - 1];
    }

    function render() {
      var v = currentVariant();
      var base = v ? v.price : parseInt(pdp.dataset.dmMinPrice || '0', 10);
      var total = base + (state.emb ? embPrice : 0);
      if (priceEl) priceEl.textContent = formatMoney(total);
      if (stickyPrice) stickyPrice.textContent = formatMoney(total);

      var embPill = $('[data-dm-emb-pill]', pdp);
      if (embPill) embPill.hidden = !state.emb;

      var sizeName = sizeOptionName();
      var chosenSize = state.options[sizeName];
      var legend = $('[data-dm-size-value]', pdp);
      if (legend) legend.textContent = chosenSize || 'sin elegir';

      var hint = $('[data-dm-size-hint]', pdp);
      var ok = $('[data-dm-size-ok]', pdp);
      var ready = v && v.available;
      if (hint) hint.hidden = !!chosenSize;
      if (ok) ok.hidden = !ready;

      if (addBtn) {
        if (!chosenSize && pdp.dataset.dmHasSizes === 'true') {
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.textContent = 'Elige una talla';
        } else if (!ready) {
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.textContent = 'Agotado';
        } else {
          addBtn.removeAttribute('aria-disabled');
          addBtn.textContent = 'Agregar al carrito';
        }
      }
      $$('[data-dm-sticky-add]').forEach(function (b) {
        if ((!chosenSize && pdp.dataset.dmHasSizes === 'true') || !ready) { b.setAttribute('aria-disabled', 'true'); b.textContent = 'Elige talla'; }
        else { b.removeAttribute('aria-disabled'); b.textContent = 'Agregar'; }
      });
      if (stickySize) {
        if (pdp.dataset.dmHasSizes !== 'true') {
          stickySize.textContent = '';
          stickySize.setAttribute('data-empty', 'false');
        } else {
          stickySize.textContent = chosenSize ? 'Talla ' + chosenSize : 'Sin talla elegida';
          stickySize.setAttribute('data-empty', String(!chosenSize));
        }
      }
      if (variantField && v) {
        var nextVariantId = String(v.id);
        var variantChanged = variantField.value !== nextVariantId;
        variantField.value = nextVariantId;
        if (variantChanged) {
          variantField.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var nextVariantState = nextVariantId + ':' + String(v.available);
        if (announcedVariantState !== nextVariantState) {
          announcedVariantState = nextVariantState;
          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variantId: nextVariantId, available: v.available }
          }));
        }
      }
    }

    // Option pickers
    $$('[data-dm-option]', pdp).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-disabled') === 'true') return;
        var name = btn.dataset.dmOption;
        state.options[name] = btn.dataset.value;
        // Match on the dataset rather than building an attribute selector: option
        // names carry spaces and accents ("Color o diseño"), which selectors escape
        // inconsistently across browsers.
        $$('[data-dm-option]', pdp).forEach(function (b) {
          if (b.dataset.dmOption === name) b.setAttribute('aria-pressed', String(b === btn));
        });
        $$('[data-dm-option-value]', pdp).forEach(function (out) {
          if (out.dataset.dmOptionValue === name) out.textContent = btn.dataset.value;
        });
        // A colour change swaps the gallery to that variant's image.
        if (btn.dataset.mediaIndex) goToSlide(parseInt(btn.dataset.mediaIndex, 10));
        render();
      });
      if (btn.getAttribute('aria-pressed') === 'true') state.options[btn.dataset.dmOption] = btn.dataset.value;
    });

    // An option with no picker on the page — a single-variant product, or an option
    // the buy box does not surface — is satisfied by the first available variant.
    // Without this the CTA would stay on "Elige una talla" with nothing to choose.
    (function fillUnpickedOptions() {
      var pickable = {};
      $$('[data-dm-option]', pdp).forEach(function (b) { pickable[b.dataset.dmOption] = true; });
      var seed = variants.filter(function (v) { return v.available; })[0] || variants[0];
      if (!seed) return;
      optionNames.forEach(function (name, i) {
        if (!pickable[name]) state.options[name] = seed.options[i];
      });
    })();

    // Quantity
    var qtyInput = $('[data-dm-qty]', pdp);
    $$('[data-dm-qty-step]', pdp).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var next = Math.min(99, Math.max(1, parseInt(qtyInput.value, 10) + parseInt(b.dataset.dmQtyStep, 10)));
        qtyInput.value = next;
        state.qty = next;
        $('[data-dm-qty-step="-1"]', pdp).disabled = next <= 1;
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      state.qty = Math.min(99, Math.max(1, parseInt(qtyInput.value, 10) || 1));
      qtyInput.value = state.qty;
    });

    // Embroidery
    var embToggle = $('[data-dm-emb-toggle]', pdp);
    var embPanel = $('[data-dm-emb-panel]', pdp);
    var embInput = $('[data-dm-emb-name]', pdp);
    var embPreview = $('[data-dm-emb-preview]', pdp);
    var embCount = $('[data-dm-emb-count]', pdp);
    if (embToggle) {
      embToggle.addEventListener('change', function () {
        state.emb = embToggle.checked;
        if (embInput) {
          embInput.required = state.emb;
          embInput.setCustomValidity('');
        }
        if (embPanel) embPanel.hidden = !state.emb;
        render();
      });
    }
    if (embInput) {
      embInput.addEventListener('input', function () {
        embInput.setCustomValidity('');
        var v = embInput.value.slice(0, 10);
        if (embInput.value !== v) embInput.value = v;
        if (embPreview) {
          embPreview.hidden = !v;
          var t = $('[data-dm-emb-preview-text]', pdp);
          if (t) t.textContent = v;
        }
        if (embCount) embCount.textContent = v.length + ' de 10 caracteres.';
      });
    }

    // Gallery
    var track = $('[data-dm-track]', pdp);
    function goToSlide(i, instant) {
      if (!track) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      markSlide(i);
    }
    function markSlide(i) {
      $$('[data-dm-thumb]', pdp).forEach(function (t, idx) { t.setAttribute('aria-current', String(idx === i)); });
      $$('[data-dm-dot]', pdp).forEach(function (t, idx) { t.setAttribute('aria-current', String(idx === i)); });
    }
    $$('[data-dm-thumb], [data-dm-dot]', pdp).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); goToSlide(parseInt(b.dataset.index, 10)); });
    });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          markSlide(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
        });
      });
    }
    // The gallery starts at the first photo even when Liquid preselected a colour
    // (the first available variant, or ?variant= in the URL): open on that colour's
    // photo, without animating.
    var pressedColour = $$('[data-dm-option][data-media-index][aria-pressed="true"]', pdp)[0];
    if (pressedColour) goToSlide(parseInt(pressedColour.dataset.mediaIndex, 10) || 0, true);

    // Related-product tabs
    $$('[data-dm-tab]', pdp).forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        $$('[data-dm-tab]', pdp).forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
        $$('[data-dm-tabpanel]', pdp).forEach(function (p) { p.hidden = p.dataset.dmTabpanel !== tab.dataset.dmTab; });
      });
    });

    // Add to cart. When embroidery is on we add two line items — the garment with
    // a "Nombre bordado" property and the bordado-personalizado product — which is
    // the mechanism the live theme already uses.
    var form = $('[data-dm-form]', pdp);
    function buildCartItems() {
      var v = currentVariant();
      if (!v || !v.available) return null;
      var name = state.emb && embInput ? embInput.value.trim() : '';
      if (state.emb && (!name || name.length > 10)) return null;
      var items = [{ id: v.id, quantity: state.qty }];
      if (name) {
        items[0].properties = { 'Nombre bordado': name };
        var embVariant = pdp.dataset.dmEmbVariant;
        if (!/^\d+$/.test(String(embVariant || ''))) return null;
        items.push({
          id: embVariant,
          quantity: state.qty,
          properties: { 'Para': pdp.dataset.dmTitle, 'Nombre': name }
        });
      }
      return { currentVariantId: String(v.id), items: items };
    }
    pdp.__sewdleBuildCartItems = buildCartItems;
    if (form) {
      form.__sewdleBuildCartItems = buildCartItems;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (pdp.dataset.dmAdding === 'true') return;
        if (state.emb && embInput && !embInput.value.trim()) {
          embInput.setCustomValidity('Escribe el nombre que quieres bordar.');
          embInput.reportValidity();
          embInput.focus();
          return;
        }
        var selection = buildCartItems();
        if (!selection) {
          var sizes = $('[data-dm-sizes]', pdp);
          if (sizes) sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var items = selection.items;
        pdp.dataset.dmAdding = 'true';
        var label = addBtn.textContent;
        addBtn.textContent = 'Agregando…';
        addBtn.setAttribute('aria-disabled', 'true');
        Cart.add(items)
          .then(function () { return Cart.refresh(); })
          .then(function () {
            pdp.dataset.dmAdding = 'false';
            addBtn.textContent = label;
            addBtn.removeAttribute('aria-disabled');
            Overlay.show('dm-cart');
          })
          .catch(function (err) {
            pdp.dataset.dmAdding = 'false';
            addBtn.textContent = label;
            addBtn.removeAttribute('aria-disabled');
            alert(err.message);
          });
      });
    }

    // Sticky bar appears once the real CTA leaves the viewport.
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyBar.setAttribute('data-show', String(!entries[0].isIntersecting));
      }, { rootMargin: '0px 0px -10% 0px' }).observe(addBtn);
    }
    $$('[data-dm-sticky-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (b.getAttribute('aria-disabled') === 'true') {
          var sizes = $('[data-dm-sizes]', pdp);
          if (sizes) sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    });

    render();
  }

  /* ---------------- Hero video ----------------
     El <video> llega con preload="none" y sin src: no pide un solo byte hasta que
     decidimos aquí. Solo arranca si el hero está en pantalla, el visitante no pidió
     reducir movimiento, no está en ahorro de datos y la conexión no es lenta. En
     cualquier otro caso se queda el póster, que ya está pintado. */
  (function heroVideo() {
    var video = $('[data-dm-hero-video]');
    if (!video) return;

    var conn = navigator.connection || {};
    var slow = conn.saveData === true || /(^|-)2g$|^3g$/.test(conn.effectiveType || '');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slow || reduce) return;

    var toggle = $('[data-dm-hero-toggle]');
    var iconPause = $('[data-dm-hero-icon-pause]');
    var iconPlay = $('[data-dm-hero-icon-play]');

    function paintToggle() {
      if (!toggle) return;
      var playing = !video.paused;
      toggle.setAttribute('aria-label', playing ? 'Pausar el video' : 'Reproducir el video');
      if (iconPause) iconPause.hidden = !playing;
      if (iconPlay) iconPlay.hidden = playing;
    }

    function start() {
      if (video.src) return;
      var mobile = window.matchMedia('(max-width: 767px)').matches;
      video.src = (mobile ? video.dataset.srcMobile : video.dataset.srcDesktop) || video.dataset.srcDesktop;
      video.load();
      // El video solo se revela cuando ya está pintando fotogramas; hasta entonces
      // manda el póster.
      video.addEventListener('playing', function () { video.setAttribute('data-playing', 'true'); }, { once: true });
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* el navegador bloqueó el autoplay: queda el póster */ });
      if (toggle) { toggle.hidden = false; paintToggle(); }
    }

    function whenIdle(fn) {
      if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 2500 });
      else setTimeout(fn, 400);
    }

    // Después de `load` para no competir por ancho de banda con el póster ni con el CSS.
    // Sin IntersectionObserver a propósito: el hero es la primera sección, siempre está
    // en pantalla al cargar, así que observarlo no ahorra nada y agrega un modo de fallo
    // (si el observer no entrega — extensiones, entornos automatizados — el video se
    // queda sin cargar en silencio y solo se ve el póster).
    function arm() { whenIdle(start); }
    if (document.readyState === 'complete') arm();
    else window.addEventListener('load', arm);

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) video.play(); else video.pause();
        paintToggle();
      });
    }
    // Un video que no se ve no debe seguir decodificando.
    document.addEventListener('visibilitychange', function () {
      if (!video.src) return;
      if (document.hidden) video.pause();
      else if (toggle && toggle.getAttribute('aria-label') === 'Pausar el video') video.play();
    });
  })();

  /* ---------------- Cuenta atrás de la barra de anuncio ----------------
     Plazo fijo, igual para todos. Se interpreta en hora de Colombia (-05:00) y no en la
     del visitante: si no, alguien en otro huso vería un plazo distinto al real.
     Al vencer no se congela en 00:00:00 — se cambia al mensaje de reemplazo. */
  (function announceCountdown() {
    var bar = $('[data-dm-countdown]');
    if (!bar) return;
    var clock = $('[data-dm-countdown-clock]', bar);
    var timer = $('[data-dm-countdown-timer]', bar);
    var promo = $('[data-dm-countdown-promo]', bar);
    var expired = $('[data-dm-countdown-expired]', bar);
    var a11y = $('[data-dm-countdown-a11y]', bar);
    if (!clock || !timer) return;

    var raw = (bar.dataset.deadline || '').trim();
    // "AAAA-MM-DD HH:MM" en hora de Colombia -> instante absoluto.
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
    if (!m) return;
    var end = new Date(m[1] + '-' + m[2] + '-' + m[3] + 'T' + m[4] + ':' + m[5] + ':00-05:00').getTime();
    if (!end) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function finish() {
      timer.hidden = true;
      if (expired) { if (promo) promo.hidden = true; expired.hidden = false; }
    }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) { finish(); return false; }
      var h = Math.floor(left / 3600000);
      var mn = Math.floor(left / 60000) % 60;
      var sc = Math.floor(left / 1000) % 60;
      clock.textContent = pad(h) + ':' + pad(mn) + ':' + pad(sc);
      // Solo para lectores de pantalla, y sin aria-live: se lee al enfocar, no cada segundo.
      if (a11y) a11y.textContent = 'Quedan ' + h + ' horas y ' + mn + ' minutos.';
      return true;
    }

    if (!tick()) return;
    timer.hidden = false;
    var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
    // Al volver de una pestaña en segundo plano el reloj puede haber quedado atrás.
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  })();

  /* ---------------- Predictive search ---------------- */
  var searchInput = $('[data-dm-search-input]');
  if (searchInput) {
    var results = $('[data-dm-search-results]');
    var suggest = $('[data-dm-search-suggest]');
    var empty = $('[data-dm-search-empty]');
    var timer;

    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = searchInput.value.trim();
      if (q.length < 2) {
        if (suggest) suggest.hidden = false;
        if (results) results.hidden = true;
        if (empty) empty.hidden = true;
        return;
      }
      timer = setTimeout(function () { run(q); }, 220);
    });

    function run(q) {
      var url = window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        var products = (data.resources.results.products || []);
        if (suggest) suggest.hidden = true;
        if (!products.length) {
          if (results) results.hidden = true;
          if (empty) { empty.hidden = false; $('[data-dm-search-term]').textContent = q; }
          return;
        }
        if (empty) empty.hidden = true;
        if (!results) return;
        results.hidden = false;
        var list = $('[data-dm-search-list]', results);
        list.innerHTML = '';
        products.forEach(function (p) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.className = 'dm-search__hit';
          a.href = p.url;
          a.innerHTML =
            '<span class="dm-search__thumb" role="presentation"></span>' +
            '<span style="flex:1;min-width:0">' +
            '<span class="dm-search__name"></span>' +
            '<span class="dm-search__meta"></span>' +
            '</span>';
          if (p.featured_image && p.featured_image.url) {
            a.querySelector('.dm-search__thumb').style.backgroundImage = "url('" + p.featured_image.url + "')";
          }
          a.querySelector('.dm-search__name').textContent = p.title;
          // OJO: suggest.json devuelve el precio en pesos ("87200.00"), no en centavos como
          // el resto de las APIs de Shopify. Con parseInt y formatMoney —que divide entre
          // 100— una ruana de $87.200 salía como "$872". Se pasa a centavos antes de
          // formatear para que la búsqueda y la ficha digan lo mismo.
          var cents = p.price ? Math.round(parseFloat(p.price) * 100) : NaN;
          a.querySelector('.dm-search__meta').textContent =
            (isNaN(cents) ? '' : formatMoney(cents)) + (p.available ? '' : ' · agotado');
          li.appendChild(a);
          list.appendChild(li);
        });
        var count = $('[data-dm-search-count]', results);
        if (count) count.textContent = products.length + (products.length === 1 ? ' resultado' : ' resultados');
      }).catch(function () { /* search stays usable via the form's normal submit */ });
    }
  }

  /* ---------------- Newsletter validation ---------------- */
  $$('form.dm-news__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var email = $('input[type=email]', form);
      var err = $('[data-dm-news-error]', form);
      if (email && !/.+@.+\..+/.test(email.value)) {
        e.preventDefault();
        if (err) err.hidden = false;
        email.focus();
      } else if (err) {
        err.hidden = true;
      }
    });
  });

  /* ---------------- Cart drawer line edits ---------------- */
  var cartLineEditInFlight = false;
  function setCartLineBusy(busy) {
    $$('[data-dm-cart-change]').forEach(function (control) {
      if (busy) control.setAttribute('aria-disabled', 'true');
      else control.removeAttribute('aria-disabled');
    });
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-dm-cart-change]');
    if (!link) return;
    e.preventDefault();
    if (cartLineEditInFlight) return;
    var key = link.dataset.key;
    var quantity = parseInt(link.dataset.qty, 10);
    if (!key || !Number.isFinite(quantity) || quantity < 0) return;
    cartLineEditInFlight = true;
    setCartLineBusy(true);
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw new Error(body.description || body.message || 'No pudimos actualizar tu bolsa.');
        return Cart.refresh();
      });
    }).catch(function (error) {
      alert(error.message || 'No pudimos actualizar tu bolsa. Vuelve a intentarlo.');
    }).finally(function () {
      cartLineEditInFlight = false;
      setCartLineBusy(false);
    });
  });
})();
